module.exports = __webpack_public_path__ + "img/h-page4-45.d5752b50.png";